import {Component, inject, input} from '@angular/core';
import {Paddock} from "src/app/infrastructure/moovement-api/models/asset";
import {PaddockSvgComponent} from 'src/app/presentation/common/icons/paddock-svg/paddock-svg.component';
import {Router} from '@angular/router';

@Component({
  selector: 'app-paddock-button',
  imports: [
    PaddockSvgComponent
  ],
  templateUrl: './paddock-button.component.html',
  styleUrl: './paddock-button.component.css'
})
export class PaddockButtonComponent {

  paddock = input.required<Paddock>();

  private router = inject(Router);

  focus() {
    const id = this.paddock()?.id;
    if (!id) return;

    this.router.navigate(["/main/customize-paddock", id]);
  }
}
